'use client';

import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import button from '../../../cva/button';
import Portal from '../../../portal';
import CyberMondayForm from './cyber-monday-form';

const CyberMondayModal: React.FC<{
  toggle: () => void;
}> = (props) => {
  const {
    toggle,
  } = props;

  const [submitted, setSubmitted] = useState(false);

  const handleSubmitted = () => {
    setSubmitted(true);
  };

  const handleCloseClick = () => {
    toggle();
    setSubmitted(false);
  };

  return (
    <Portal>
      <div className="modal modal-open z-[9999999999]">
        <div className="modal-box p-0">
          {submitted ? (
            <div className="px-6 pb-6 pt-10 lg:p-20 flex flex-col items-center justify-center gap-8 h-full">
              <FontAwesomeIcon icon={faCheck} size="3x" className="text-info" />
              <span className="text-slate-800 text-lg font-medium text-center">
                {`You'll recieve your Cyber Monday deals soon. Keep an eye out!`}
              </span>
              <button className={button({ intent: 'secondary', block: true })} onClick={toggle}>
                Close
              </button>
            </div>
          ) : (
            <>
              <div className="p-px flex justify-between items-center">
                <p className="px-6 text-slate-600">
                  Cyber Monday Deals
                </p>

                <button className="btn btn-ghost btn-square rounded-2xl rounded-b rounded-tl" onClick={handleCloseClick}>
                  <FontAwesomeIcon icon={faClose} size="2x" />
                </button>
              </div>

              <p className="px-6 bg-slate-100 py-2 md:py-4 text-slate-800 font-medium font-lg">
                {`Enter your details to receive the Cyber Monday offers.`}
              </p>

              <div className="px-6 pt-4 pb-6">
                <CyberMondayForm
                  onSubmitted={handleSubmitted}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </Portal>
  );
};

export default CyberMondayModal;
